<template>
  <div class="page-title spaceBetween">
    <div class="spaceLeft">
      <svg-icon
        v-if="back"
        class="goback"
        icon-class="tn-goback"
        @click="goback"
      />
      {{ title }}
    </div>
    <div>
      <slot />
    </div>

  </div>
</template>

<script>
export default {
  components: {},
  props: {
    back: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    title() {
      return this.$route.meta ? this.$route.meta.title : 'Undfined Title'
    }
  },
  created() {},
  methods: {
    goback() {
      this.$emit('goback')
    }
  }
}
</script>
<style scoped>
.page-title {
  font-size: 0.26rem;
  color: #000;
  font-weight: bold;
  margin-bottom: 0.24rem;
}
.goback {
  width: 0.2rem;
  height: 0.2rem;
  margin-right: 10px;
  cursor: pointer;
}
</style>
